<template>
  <v-container fluid>
    <validation-observer v-slot="{ invalid }">
      <v-row>
        <v-col>
          <base-material-card color="primary" icon="mdi-badge-account" inline class="px-5 py-3">
            <template v-slot:after-heading>
              <div class="display-1 font-weight-light">
                {{ labelHeading }}
              </div>
            </template>
            <v-form class="pt-5">
              <v-row align="center" no-gutters class="ml-0">
                <v-col cols="12">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <v-text-field
                      v-model="email"
                      label="Email"
                      outlined
                      class="ml-4"
                      :disabled="$route.params.id ? true : false"
                      prepend-icon="mdi-email"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row align="center" no-gutters class="ml-0">
                <v-col cols="12">
                  <v-text-field
                    v-if="!$route.params.id"
                    v-model="senha"
                    autocomplete="new-password"
                    :append-icon="iconEye ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="iconEye ? 'text' : 'password'"
                    label="Senha"
                    messages="Deixando este campo em branco, o usuário será criado com senha aleatória e a mesma enviada por e-mail"
                    outlined
                    class="ml-4"
                    prepend-icon="mdi-key"
                    @click:append="iconEye = !iconEye"
                  />
                </v-col>
              </v-row>
              <v-row align="center" no-gutters class="ml-0">
                <v-col cols="12">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <v-text-field
                      v-model="nome"
                      label="Primeiro Nome"
                      outlined
                      class="ml-4"
                      :error-messages="errors"
                      prepend-icon="mdi-face"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row align="center" no-gutters class="ml-0">
                <v-col cols="12">
                  <v-text-field v-model="sobrenome" label="Sobrenome" outlined class="ml-4" prepend-icon="mdi-account" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <validation-provider v-slot="{ errors }" ref="fieldLiberadas" rules="required">
                    <v-select
                      v-model="liberadas"
                      :items="empresas"
                      item-value="id"
                      item-text="nome"
                      chips
                      label="Empresas"
                      multiple
                      outlined
                      class="ml-4"
                      prepend-icon="mdi-home"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row v-if="$route.params.id">
                <v-col class="ml-4 mt-n8">
                  <v-checkbox v-model="desativado" prepend-icon="mdi-account-cancel" label="Desativar Usuário" />
                </v-col>
              </v-row>
              <v-row v-if="userIsAdmin">
                <v-col class="ml-4 mt-n8">
                  <v-checkbox v-model="admin" prepend-icon="mdi-account-cog" label="Administrador" />
                </v-col>
              </v-row>
            </v-form>
          </base-material-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-btn
            v-if="$route.params.id"
            color="error"
            min-width="100"
            style="float: left"
            class="mt-n5"
            :loading="loading"
            @click="showResetPasswordDialog = true"
          >
            Redefinir Senha
          </v-btn>
        </v-col>
        <v-col cols="12" md="6">
          <v-btn
            color="green"
            min-width="100"
            style="float: right"
            class="mt-n5"
            :disabled="invalid"
            :loading="loading"
            @click="postUsuarioFirebaseAuth()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>

      <!-- Modal de Confirmação para Redefinir Senha -->
      <v-dialog v-model="showResetPasswordDialog" max-width="500px">
        <v-card>
          <v-card-title class="headline">Redefinir Senha?</v-card-title>
          <v-card-text>
            Uma nova senha será gerada e enviada por email para
            <strong>{{ email }}</strong>
            .
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="grey" text @click="showResetPasswordDialog = false">Cancelar</v-btn>
            <v-btn color="red" text :loading="loading" @click="redefinirSenhaDoUsuario()">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </validation-observer>
  </v-container>
</template>

<script>
  import Firestore from '@/Firestore.js';
  import UsuariosService from '@/services/UsuariosService';
  import 'firebase/auth';
  import generateRandomString from '@/utils/generateRandomString.js';

  export default {
    data: () => ({
      iconEye: false,
      nome: '',
      sobrenome: '',
      email: '',
      senha: '',
      admin: false,
      desativado: false,
      desativadoBeforeEdit: false,
      editingUser: {},
      empresas: [],
      liberadas: [],
      liberadasBeforeEdit: [],
      empresaLiteSelecionada: false,
      loading: false,
      showResetPasswordDialog: false
    }),
    computed: {
      labelHeading() {
        return this.$route.name === 'Usuários Adicionar' ? 'Adicionar Novo Usuário' : `Editando Usuário ${this.nome}`;
      },
      user() {
        return this.$store.getters.getUser;
      },
      userIsAdmin() {
        return this.$store.getters.userIsAdmin;
      },
      userLoggedCompany() {
        return this.$store.getters.getEmpresa;
      }
    },
    mounted() {
      if (this.$route.params.id) {
        this.getUsuario();
        this.getUsuarioEmpresas();
      }
      this.getEmpresas();
    },
    methods: {
      getUsuario() {
        Firestore.collection('usuarios')
          .doc(this.$route.params.id)
          .get()
          .then((doc) => {
            this.nome = doc.data().nome;
            this.sobrenome = doc.data().sobrenome;
            this.email = doc.data().email;
            this.admin = doc.data().admin || false;
            this.desativado = doc.data().desativado || false;
            this.desativadoBeforeEdit = doc.data().desativado || false;
          });
      },
      getEmpresas() {
        this.getQueryEmpresas()
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              this.empresas.push({
                id: doc.id,
                url: doc.data().url,
                sigla: doc.data().sigla,
                database: doc.data().database,
                nome: doc.data().nome
              });
            });
          });
      },
      getQueryEmpresas() {
        let query = Firestore.collection('empresas').orderBy('nome');
        if (!this.userIsAdmin) {
          query = Firestore.collection('empresas').where('url', '==', this.userLoggedCompany);
        }
        return query;
      },
      getUsuarioEmpresas() {
        const userRef = Firestore.collection('usuarios').doc(this.$route.params.id);
        Firestore.collection('usuarios_empresas')
          .where('usuario_id', '==', userRef)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              Firestore.collection('empresas')
                .doc(doc.data().empresa_id.id)
                .get()
                .then((docEmpresas) => {
                  this.liberadas.push(docEmpresas.id);
                  this.liberadasBeforeEdit.push(docEmpresas.id);
                })
                .finally(() => this.$refs.fieldLiberadas.validate()); // Força a validação do campo
            });
          });
      },
      postUsuarioFirebaseAuth() {
        this.$toast.info('Processando...', '', { position: 'topRight', timeout: 2000 });
        this.loading = true;

        let postData = {
          email: this.email,
          senha: this.senha,
          nome: this.nome,
          sobrenome: this.sobrenome,
          uid: this.$route.params.id ? this.$route.params.id : '',
          desativado: this.desativado,
          admin: this.admin,
          empresasSelecionadas: this.liberadas
        };

        if (!this.$route.params.id) {
          if (!this.senha.trim()) {
            postData.senha = generateRandomString(8);
            this.senha = postData.senha;
          }

          UsuariosService.cadastroUsuarioFirebase(postData)
            .then((response) => {
              this.editingUser = {
                id: response.data.uid,
                email: this.email
              };
              this.postUsuarioHexa();
            })
            .catch((error) => {
              console.error(error);
              this.loading = false;
              this.$toast.error('Erro ao salvar usuário.', '', { position: 'topRight' });
            });
        } else {
          UsuariosService.cadastroUsuarioFirebase(postData)
            .then(() => {
              if (this.desativadoBeforeEdit != postData.desativado) {
                this.manageStatusFirebaseAuth(this.$route.params.id, !this.desativado);
              }
              this.postUsuarioHexa();
            })
            .catch((error) => {
              console.error(error);
              this.$toast.error('Erro ao salvar usuário.', '', { position: 'topRight' });
              this.loading = false;
            });
        }
      },
      manageStatusFirebaseAuth(uid, status) {
        return UsuariosService.manageStatusFirebaseAuth({ uid, status }).catch((error) => {
          console.error(error);
          throw new Error(error);
        });
      },
      async postUsuarioHexa() {
        this.empresaLiteSelecionada = false;

        let urlEmpresasSelecionadas = [];
        let urlEmpresasDesvinculadas = [];

        let postData = {
          nome: this.nome + ' ' + this.sobrenome,
          email: this.email,
          uid: this.$route.params.id ? this.$route.params.id : this.editingUser.id,
          status: !this.desativado,
          admin: this.admin,
          senha: this.senha
        };

        if (process.env.NODE_ENV === 'production') {
          let desvinculadas = this.liberadasBeforeEdit.filter((el) => !this.liberadas.includes(el));

          this.empresas.forEach((empresa) => {
            /* Monta um array com as empressas selecionadas */
            if (this.liberadas.includes(empresa.id)) {
              if (empresa.sigla == 'LITE') {
                this.empresaLiteSelecionada = true;
              }

              urlEmpresasSelecionadas.push(`https://${empresa.url}.gestaohexa.com.br/api`);
            } else if (desvinculadas.includes(empresa.id)) {
              /* Quando tiver em modo edicao monta um array com as empresas que forem desmarcadas */
              urlEmpresasDesvinculadas.push(`https://${empresa.url}.gestaohexa.com.br/api`);
            }
          });
        } else {
          urlEmpresasSelecionadas = [process.env.VUE_APP_API_BASE_URL];
        }

        let requests = [];
        urlEmpresasSelecionadas.forEach((url) => requests.push(this.getPostUsuarioHexaRequest(postData, url)));
        if (!this.$route.params.id) requests.push(this.enviaSenhaPorEmail());

        /* Desativa no BD as empresas que foram removidas da seleção */
        postData.status = false;
        urlEmpresasDesvinculadas.forEach((url) => requests.push(this.getPostUsuarioHexaRequest(postData, url)));
        /* Espera todas as requests terminarem */
        await Promise.all(requests)
          .then(() => {
            this.$toast.success('Usuário salvo com sucesso.', '', { position: 'topRight' });
            this.$router.push({ name: 'Usuários' });
          })
          .catch(() => {
            this.$toast.error('Erro ao salvar Usuário.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },
      getPostUsuarioHexaRequest(postData, url) {
        return UsuariosService.postUsuarioFromFirebase(this.user.uid, postData, url).catch((error) => {
          throw new Error(error);
        });
      },
      enviaSenhaPorEmail() {
        if (this.$route.params.id) return; // Só envia caso seja novo usuario

        const modeloEmail = this.empresaLiteSelecionada ? 'envia_senha_por_email_v2_hexa_lite' : 'envia_senha_por_email_v2';

        return UsuariosService.sendPasswordByEmail(this.email, this.senha, modeloEmail).catch((err) => {
          this.$toast.error('Erro ao enviar email para o usuário.', '', { position: 'topRight' });
          console.error(`Erro ao enviar email para o usuário [${this.email}]: `, err);
        });
      },
      redefinirSenhaDoUsuario() {
        this.loading = true;
        const uid = this.$route.params.id;

        UsuariosService.resetUserPasswordByUid(uid)
          .then(() => {
            this.$toast.success('Senha redefinida e enviada por email com sucesso.', '', { position: 'topRight' });
            this.showResetPasswordDialog = false;
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao redefinir a senha do usuário.', '', { position: 'topRight' });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
</script>
